export default __webpack_public_path__ + "static/media/favicon.a1889463.png";